/**
 * Часовые пояса для выбора при регистрации.
 *
 * Список ограничен Россией и ближним зарубежьем: полный перечень IANA —
 * это шесть сотен строк, среди которых человек ищет свой город дольше,
 * чем заполняет всю остальную форму. Если понадобится пояс вне списка,
 * добавим поле для ручного ввода — сервер принимает любую строку, которую
 * понимает tzdata.
 */

export interface TimezoneOption {
  value: string
  label: string
  /** Смещение от Москвы в часах — им и сортируем. */
  offset: number
}

export const TIMEZONES: TimezoneOption[] = [
  { value: 'Europe/Kaliningrad', label: 'Калининград (МСК−1)', offset: -1 },
  { value: 'Europe/Moscow', label: 'Москва, Санкт-Петербург (МСК)', offset: 0 },
  { value: 'Europe/Samara', label: 'Самара, Ижевск (МСК+1)', offset: 1 },
  { value: 'Asia/Yekaterinburg', label: 'Екатеринбург, Пермь, Уфа (МСК+2)', offset: 2 },
  { value: 'Asia/Omsk', label: 'Омск (МСК+3)', offset: 3 },
  { value: 'Asia/Novosibirsk', label: 'Новосибирск, Барнаул, Томск (МСК+4)', offset: 4 },
  { value: 'Asia/Krasnoyarsk', label: 'Красноярск, Кемерово (МСК+4)', offset: 4 },
  { value: 'Asia/Irkutsk', label: 'Иркутск, Улан-Удэ (МСК+5)', offset: 5 },
  { value: 'Asia/Yakutsk', label: 'Якутск, Чита (МСК+6)', offset: 6 },
  { value: 'Asia/Vladivostok', label: 'Владивосток, Хабаровск (МСК+7)', offset: 7 },
  { value: 'Asia/Magadan', label: 'Магадан, Сахалин (МСК+8)', offset: 8 },
  { value: 'Asia/Kamchatka', label: 'Петропавловск-Камчатский (МСК+9)', offset: 9 },
  { value: 'Europe/Minsk', label: 'Минск (МСК)', offset: 0 },
  { value: 'Asia/Almaty', label: 'Алматы, Астана (МСК+2)', offset: 2 },
  { value: 'Asia/Tashkent', label: 'Ташкент (МСК+2)', offset: 2 },
  { value: 'Asia/Tbilisi', label: 'Тбилиси (МСК+1)', offset: 1 },
  { value: 'Asia/Yerevan', label: 'Ереван (МСК+1)', offset: 1 },
  { value: 'Asia/Baku', label: 'Баку (МСК+1)', offset: 1 },
]

export const DEFAULT_TIMEZONE = 'Europe/Moscow'

/**
 * Угадывает пояс по настройкам браузера.
 *
 * Подставляется как значение по умолчанию в форме регистрации: в
 * подавляющем большинстве случаев угадывает верно, а человек всё равно
 * видит выбранное и может поменять.
 */
export function guessTimezone(): string {
  try {
    const guess = Intl.DateTimeFormat().resolvedOptions().timeZone
    return TIMEZONES.some((tz) => tz.value === guess) ? guess : DEFAULT_TIMEZONE
  } catch {
    return DEFAULT_TIMEZONE
  }
}

export function timezoneLabel(value: string): string {
  return TIMEZONES.find((tz) => tz.value === value)?.label ?? value
}
